import { createContext, PropsWithChildren, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";

type MapEditorFeatureHoverContextValue = {
    clear: () => void;
    set: (nextValue: string) => void;
    mapEditorFeatureId?: string;
};

const mapEditorFeatureHoverContext = createContext<MapEditorFeatureHoverContextValue | undefined>(undefined);

export function MapEditorFeatureHoverProvider({ children }: PropsWithChildren) {
    const [hoveredMapEditorFeatureId, setHoveredMapEditorFeatureId] = useState<string>();
    const location = useLocation();

    // biome-ignore lint/correctness/useExhaustiveDependencies: should trigger when `pathname` changes
    useEffect(() => {
        setHoveredMapEditorFeatureId(undefined);
    }, [location.pathname]);

    const value = useMemo<MapEditorFeatureHoverContextValue>(
        () => ({
            mapEditorFeatureId: hoveredMapEditorFeatureId,
            clear: () => setHoveredMapEditorFeatureId(undefined),
            set: (next: string) => setHoveredMapEditorFeatureId(next),
        }),
        [hoveredMapEditorFeatureId],
    );

    return <mapEditorFeatureHoverContext.Provider value={value}>{children}</mapEditorFeatureHoverContext.Provider>;
}

export function useMapEditorFeatureHover() {
    const context = useContext(mapEditorFeatureHoverContext);
    if (!context) throw new Error("useMapEditorFeatureHover must be used within a MapEditorFeatureHoverProvider");

    return context;
}
